require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /Volumes/Data HD/Git-UI/uikit-fullscreen/~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 301
// module chunks = 0